export default "__VITE_ASSET__BjAUjK8z__"